/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GenericModal from './CheckRefundableTransactionModal'
import { nullSafe } from 'Utility/globalMethods'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = state => ({
  userRole: nullSafe(() => state.popup.popupInfo.userRole, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GenericModal)
